import { Directive } from "@angular/core"

@Directive({
    selector: '.escolhaVinculo1',
    standalone: false
})
export class EscolhaVinculo1RadioOptionElement {
}

@Directive({
    selector: '.escolhaVinculo2',
    standalone: false
})
export class EscolhaVinculo2RadioOptionElement {
}


@Directive({
    selector: '.perguntaConcorda1',
    standalone: false
})
export class PerguntaConcorda1RadioOptionElement {
}


@Directive({
    selector: '.perguntaConcorda2',
    standalone: false
})
export class PerguntaConcorda2RadioOptionElement {
}
